<template>
    <div
        :class="{ 'is-active': active }"
        class="dropdown"
        @click="$emit('click')"
    >
        <div class="dropdown-trigger">
            <button
                class="button"
                aria-haspopup="true"
                aria-controls="dropdown-menu"
            >
                <span class="lb-search-dropdown-filter-label"
                    >{{ $t(text) }}:
                </span>
                <span class="has-text-weight-bold pl-1">
                    {{ filter }}
                </span>
                <span class="icon is-small">
                    <i class="fas fa-angle-down" aria-hidden="true"></i>
                </span>
            </button>
        </div>
        <div class="dropdown-menu" role="menu">
            <div class="dropdown-content">
                <a
                    v-for="option in options"
                    :key="option"
                    :class="{ 'is-active': option == filter }"
                    class="dropdown-item is-size-6"
                    @click="$emit('update:filter', option)"
                    >{{ option }}</a
                >
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        filter: {
            type: String,
            required: true,
        },
        active: {
            type: Boolean,
            required: true,
            default: false,
        },
        options: {
            type: Array,
            required: true,
            default() {
                return [];
            },
        },
        /*text: {
      type: String,
      default: this.$t("App.dropdown_filter")
    }*/
        text: {
            type: String,
            default: 'App.dropdown_filter',
        },
    },
    data() {
        return {};
    },
    computed: {},
};
</script>

<style></style>
